// export const HOST = 'https://localhost:3000'
export const HOST = process.env.REACT_APP_API_HOST;
export const DEFAULT_LOCALE = "es";
